import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useTenantRestoreMutation } from "@/v2-backoffice-client/tenant/restore/tenant.restore.mutation"

export type TenantRestoreMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  tenantId: number | null | undefined
  confirmDescription?: string
  onCompleted?(): void
}

function TenantRestoreMenuItem(props: TenantRestoreMenuItemProps) {
  const { tenantId, confirmDescription, onCompleted, ...menuItemProps } = props

  const [restoreTenant, { loading, error }] = useTenantRestoreMutation({
    onCompleted,
  })

  return (
    <ActionMenu.ConfirmItem
      iconSrc="undo-alt"
      variant="success"
      isLoading={loading}
      error={error}
      errorTitle="Failed to restore team"
      disabled={!tenantId}
      confirmTitle="Restore Team"
      confirmDescription={
        confirmDescription ?? "Are you sure you want to restore this team?"
      }
      confirmText="Restore"
      confirmVariant="success"
      onConfirm={async () => {
        if (!tenantId) return
        await restoreTenant({ variables: { id: tenantId } })
      }}
      {...menuItemProps}
    >
      Restore Team
    </ActionMenu.ConfirmItem>
  )
}

export default TenantRestoreMenuItem
